export const MailSign = 'mail-signature';
export const SocialLink = 'edm-social-link';
export const MailSignEnt = 'mail-signature-ent';
export const MailPreMailContent = 'pre-mail-content';
export const MailForwardContent = 'isForwardContent';
export const PreHeader = 'preheader-waimao';
export const UnSubText = 'un_sub_text';
export const SubText = 'sub_text';
export const emptyLine = 'edm-empty-line';
export const editVar = 'editVar';
export const NotContentSelector = {
    className: [MailSign, MailSignEnt, UnSubText, editVar],
    id: [PreHeader],
};
